<template>
	<div class="publiccartoon" style="min-height:60vh">
		<div class="noresult-dw">
			<searchzj ref="nosearch"></searchzj>
		</div>
		<div class="Cartoon-con-one" v-for="(item, index) in paintllist" :key="index">
			<img :src="item.cover_pic" alt class="Cartoon-con-one-left" />
			<div class="Cartoon-con-one-right">
				<p class="Cartoon-con-one-right-p">{{item.title}}</p>
				<p class="Cartoon-con-one-right-p1">作者：{{item.author}}</p>
				<div class="Cartoon-con-one-right-p1 bookcate">
					<span>题材：</span>
					<div v-for="(item, index) in item.bookcate" :key="index">
						<span v-if="index!=0">/</span>
						{{item}}
					</div>
				</div>
				<p class="Cartoon-con-one-right-p1" v-if="item.status==1">状态：连载中</p>
				<p class="Cartoon-con-one-right-p1" v-if="item.status==2">状态：已完结</p>
				<p class="Cartoon-con-one-right-p2">{{item.summary}}</p>
				<p class="Cartoon-con-one-right-p3">
					更新至：
					<span class="Cartoon-con-one-right-span">{{item.episodes[0].title}}</span>
				</p>
			</div>
		</div>
		<publicpaging></publicpaging>
	</div>
</template>

<script>
	import publicpaging from "../publicpaging.vue";
	import searchzj from "../searchzj.vue";
	export default {
		name: "App",
		props: ["flag", "f", "active"],
		components: {
			publicpaging,
			searchzj
		},
		data() {
			return {
				paintllist: ""
			};
		},
		methods: {
			getsearch(title) {
				this.$http.get(`search/show/?type=paint&title=${title}`).then(res => {
					if (res.body.code == 1) {
						this.paintllist = res.body.data;
						if (res.body.msg == "暂无此数据") {
							this.$refs.nosearch.setnosearchshow(true);
						} else {
							this.$refs.nosearch.setnosearchshow(false);
						}
					}
				});
			}
		},
		created() {
      console.log(this.$route.query.searchtitle)
			if (this.$route.query.searchtitle) {
				this.getsearch(this.$route.query.searchtitle);
			}
		}
	};
</script>

<style>
	.publiccartoon {
		display: flex;
		flex-wrap: wrap;
	}
	.Cartoon-con-one {
		width: 380px;
		height: 250px;
		margin-right: 20px;
		margin-top: 30px;
		display: flex;
	}

	.Cartoon-con-one-left {
		width: 180px;
		height: 250px;
		margin-right: 16px;
		border-radius: 8px;
	}

	.Cartoon-con-one-right {
		width: 180px;
		position: relative;
	}

	.Cartoon-con-one-right-p {
		font-size: 18px;
		font-weight: bold;
		color: #212121;
	}

	.Cartoon-con-one-right-p1 {
		font-size: 14px;
		margin-top: 16px;
		color: #212121;
	}

	.Cartoon-con-one-right-p2 {
		font-size: 14px;
		margin-top: 16px;
		color: #808080;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 3;
		overflow: hidden;
	}

	.Cartoon-con-one-right-p3 {
		font-size: 14px;
		color: #808080;
		position: absolute;
		bottom: 0;
		display: flex;
		flex-direction: column;
	}

	.Cartoon-con-one-right-span {
		font-size: 14px;
		color: #28a3b1;
	}
	.noresult-dw {
		width: 100%;
		height: 174px;
		display: flex;
		justify-content: center;
		position: relative;
	}
	.bookcate {
		display: flex;
		flex-direction: row;
	}
</style>



// WEBPACK FOOTER //
// src/components/search/searchcartoon.vue